import { CoveoProductInfo, CoveoProductModel } from "@DSG/Type/CoveoModels";
import React from "react";

export interface CoveoProductContextModel {
    idx?: number;
    coveoProduct: CoveoProductModel;
    coveoProductInfo: CoveoProductInfo;
    onQtyOrderedChanged?: (qtyOrdered: number) => void;
    onUnitOfMeasureChanged?: (unitOfMeasure: string) => void;
}

export type HasProduct = CoveoProductContextModel;

export const CoveoProductContext = React.createContext<CoveoProductContextModel | undefined>(undefined);

export interface HasProductContext {
    coveoproductContext: CoveoProductContextModel;
}

export function withProductContext<P extends HasProductContext>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof HasProductContext>) {
        return (
            <CoveoProductContext.Consumer>
                {value => <Component {...(props as P)} coveoproductContext={value!} />}
            </CoveoProductContext.Consumer>
        );
    };
}

export function withProduct<P extends HasProduct>(Component: React.ComponentType<P>) {
    return function ProductComponent(props: Omit<P, keyof HasProduct>) {
        return (
            <CoveoProductContext.Consumer>
                {value => {
                    return (
                        <Component
                            {...(props as P)}
                            coveoProductInfo={value!.coveoProductInfo}
                            coveoProduct={value!.coveoProduct}
                            onQtyOrderedChanged={value!.onQtyOrderedChanged}
                        />
                    );
                }}
            </CoveoProductContext.Consumer>
        );
    };
}
